export default __webpack_public_path__ + "static/media/CircularSawImg.423991a2.png";